module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-42d9e6c4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/App.vue
// module id = 574
// module chunks = 2